import { render } from "./CategoryGridComponent.vue?vue&type=template&id=b54e77ac"
import script from "./CategoryGridComponent.vue?vue&type=script&lang=js"
export * from "./CategoryGridComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/category/CategoryGridComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b54e77ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b54e77ac', __exports__)) {
    api.reload('b54e77ac', __exports__)
  }
  
  module.hot.accept("./CategoryGridComponent.vue?vue&type=template&id=b54e77ac", () => {
    api.rerender('b54e77ac', render)
  })

}


export default __exports__